import o from "./ApiGuide.vue2.js";
import "./ApiGuide.vue3.js";
import t from "./_virtual/_plugin-vue_export-helper.js";
const i = /* @__PURE__ */ t(o, [["__scopeId", "data-v-62e0ce64"]]);
export {
  i as default
};
